import React, { useState } from "react";
import {
  Button,
  FlexRowBetween,
  FlexRowStart,
  GenericDiv,
  Input,
  Label,
  PopupForm,
  RespFont,
  TextArea,
} from "../common/Style";
import Switcher from "../common/switcher/Switcher";
import { destroyUser, editUserById } from "../../store/reducers/userReducer";
import { toast } from "react-toastify";
import YesNoModal from "../common/modals/YesNoModal";
import {
  CFV,
  exportToCSV,
  getImageUrl,
  links,
} from "../common/others/Functions";
import GCalendar from "../common/calendar/Calendar";
import GenericModal from "../common/modals/GenericModal";
import OpacityLoading from "../common/loader/OpacityLoading";
import trash from "../../assets/common/trash.svg";
import excel from "../../assets/common/excel.svg";

import notes from "../../assets/common/notes.svg";
import call from "../../assets/common/call.svg";
import whatsappW from "../../assets/common/whatsappW.svg";
import tools from "../../assets/common/menu.svg";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Stats from "./Stats";
import {
  countNotAnswered,
  sendGenericSms,
} from "../../store/reducers/dataReducer";
import EditPics from "../common/others/EditPics";
import EditPicsAdmin from "../common/others/EditPicsAdmin";
import CopyText from "../common/others/CopyText";
import { createIBSuser } from "../../store/reducers/paymentsReducer";
import { getAllGAvivit } from "../../store/reducers/guestsReducer";

const EditUser = ({ user, init, up }) => {
  const dispatch = useDispatch();
  let msg5 = `אנא קראו היטב את כל מרכיבי ההודעה ובצעו את הנדרש.
את כל הפעולות יש לבצע בהקדם האפשרי ועד יום לפני תחילת אישורי ההגעה, בהתאם ללוח הזמנים המופיע באזור האישי שלכם באתר.
בסיום, עדכנו אותי 🙏

🔹 יש לבצע 2 פעולות חשובות במערכת

🎥 סרטון 1: ״מזמין + קשר״

השדות מזמין ו קשר מיועדים לאורחים שלא מכירים את החתן והכלה אישית, אלא מוזמנים דרך המשפחה.

הסבר ברור:
* מזמין – מי שמזמין את האורח שלו בפועל
* קשר – מה הקשר של חתן או הכלה לאותו מזמין

ניתן להגדיר מזמין + קשר רק למזמינים מקרבה ראשונה:
אבא, אמא, אח, אחות, סבא, סבתא.

📌 למה זה חשוב?
כך האורח מבין מיד מי הזמין אותו ולמה קיבל את ההודעה, הפנייה אישית ומכבדת יותר, ואחוזי המענה עולים משמעותית.

דוגמה:
אם לכלה קוראים יעל ולאמא שלה קוראים רחל כהן,
אורחים שמכירים את רחל אישית,
הם יקבלו הודעה בסגנון:
“רחל כהן מזמינה אתכם לחתונת בתה יעל”

לצפייה בסרטון:
https://youtu.be/HRx9ewK3pHY

⸻

🎥 סרטון 2: ״חינמיים + ללא מספר״

בסרטון מוסבר כיצד לאתר אורחים שחסר להם מספר טלפון במערכת.

מה נדרש לבצע:
* להשלים מספרי טלפון חסרים
* לאשר בעצמכם רשומות שאין צורך שנבדוק עבורן הגעה

לצפייה בסרטון:
https://youtu.be/i2flhaDAyNc

⸻

📌 נקודה חשובה לגבי שמות אורחים
אם קיימים ברשימות שלכם שמות עם כינויים או תיאורים כגון:
“אח של”, “הבן של”, “יעקב השכן” וכדומה,
יש לערוך את השמות באתר ולהשאיר שם מלא או רק שם פרטי.

שימוש בכינויים ושמות תיאוריים אינו מכבד את האורחים ועלול לפגוע באופן הפנייה אליהם.

⸻

📌 חשוב לדעת
אין יותר שימוש באקסל.
מעכשיו כל שינוי, עדכון או הוספת אורחים מתבצעים ישירות במערכת.

במידה ותרצו להוסיף אורחים ידנית, מצורף סרטון הדרכה:
https://youtu.be/4h9PZpL8Gv8

⸻

🔔 בסיום כל הפעולות יש ללחוץ בהודעה הקופצת על:
“עשינו הכל אפשר להתחיל”

רק לאחר הלחיצה נוכל להתחיל בתהליך אישורי ההגעה.`;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [isDigitalSeat, setIsDigitalSeat] = useState(user.isDigitalSeat);
  const [sendSeatSMS, setSendSeatSMS] = useState(user.sendSeatSMS);
  const [canEditSketch, setCanEditSketch] = useState(user.canSeatExtra); // שימוש במשתנה לא פעיל למטרה אחרת
  let link = `https://callup.ltd/`;
  if (links[user.producer] != undefined) link = links[user.producer];
  let msg0 = `לינק להתחברות - ${link}\n\nמס׳ נייד - ${user.phone}\n\nסיסמא - ${user.vPassword}`;
  const [isReadyAdmin, setIsReadyAdmin] = useState(user.isReadyAdmin);

  const [isPaid, setIsPaid] = useState(user.isPaid);
  const [canChangeTodos, setCanChangeTodos] = useState(user.canChangeTodos);
  const [loading, setLoading] = useState(false);
  const [showStats, setShowStats] = useState(false);
  const [showAsmachta, setShowAsmachta] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showCalendar, setShowCalendar] = useState(null);

  const [date, setDate] = useState(new Date(user.date));

  const handleSetDate = (e) => {
    let date1 = e;
    date1.setHours(20);
    setDate(date1);
  };

  const getAllExcel = (guests) => {
    let arr = [];
    if (Object.keys(guests).length > 0)
      for (const [key, value] of Object.entries(guests)) {
        arr.push({
          "שם מלא": value.name,
          "מס׳ נייד": value.phone,
          קירבה: value.closeness,
          מוזמנים: value.sum,
          אישרו: value.accept === null ? "" : value.accept,
          מזמין: value.inviting,
          קשר: value.owc,
          הערות: value.notes,
        });
      }
    exportToCSV(arr, "כללי");
  };

  const handleGetGuests = (uid) => {
    dispatch(getAllGAvivit(uid)).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else getAllExcel(res.payload);
    });
  };

  const handleCountNotAnswered = (uid) => {
    dispatch(countNotAnswered({ uid })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else
        toast.info(
          <FlexRowBetween>
            <div>{res.payload.waze.length ? "✔️" : "❌"}</div>
            <div>{res.payload.amount}</div>
            <img
              src={excel}
              style={{ width: "25px" }}
              onClick={() => {
                if (res.payload.eventType) handleGetGuests(uid);
                else
                  toast.info(
                    "לא מדובר בחתונה ולכן אין אפשרות לבעל השמחה לעשות מזמין + קשר, שווה לבדוק האם לעשות לו או שאפשר משהו כולל - ניתן לראות לפי הקטגוריות",
                  );
              }}
            />
          </FlexRowBetween>,
        );
    });
  };

  const handleCreateIBSuser = () => {
    if (user.eventType && user.brideFN === "")
      toast.error(
        "יש להשלים פרטי אירוע, אם כבר בוצע אולי יש לרענן עמוד זה ואז לנסות ליצור לינק",
      );
    else {
      setLoading(true);
      dispatch(
        createIBSuser({
          phone: user.phone.substring(1),
          uniqueDescription: user.eventType
            ? `החתונה של ${user.brideFN + " " + user.brideLN} ו${
                user.groomFN + " " + user.groomLN
              }`
            : user.calendarName,
          producer: user.producer,
          eventDate: date,
        }),
      ).then((res) => {
        setLoading(false);
        if (!res.payload?.error) toast.success("הפעולה בוצעה בהצלחה");
        else toast.error(res.payload?.error);
      });
    }
  };

  const onSubmit = async (data) => {
    let phone = data.phone || "";
    phone = phone.replaceAll("-", "");
    phone = phone.replaceAll(/[^\d]/g, "");
    const body = {
      ...data,
      isPaid,
      isReadyAdmin,
      sendSeatSMS,
      canSeatExtra: canEditSketch,
      isDigitalSeat,
      phone,
      deal: parseFloat(data.deal) || 0,
    };
    dispatch(editUserById(user._id, body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  const handleDestroyUser = async () => {
    setLoading(true);
    dispatch(
      destroyUser({
        id: user._id,
        pic: user.pic,
        asmachta: user.asmachta,
        sketch: user.sketch,
        is180dealAcceptExtra: user.is180dealAcceptExtra,
      }),
    ).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else {
        toast.success("הפעולה בוצעה בהצלחה!");
        setShowDelete(false);
        init(null);
      }
      setLoading(false);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
      style={{ position: "relative" }}
    >
      {/* <GenericDiv
        onClick={() => setShowStats(user)}
        style={{
          position: "absolute",
          left: "0",
          top: "0",
          borderRadius: "0 0 20px 0",
          padding: "5px 9px 9px 9px",
        }}
        background={"rgba(123,150,196,0.95)"}
      >
        <img src={tools} alt="tools" style={{ width: "25px" }} />
      </GenericDiv> */}
      <div
        style={{
          width: "90%",
          margin: "15px auto",
          marginTop: "40px",
        }}
      >
        <FlexRowBetween style={{ alignItems: "baseline" }}>
          <div style={{ width: "40%" }}>
            <Label>מס׳ נייד</Label>
            <Input
              defaultValue={user.phone}
              {...register("phone", {
                pattern: /^[0]{1}[5]{1}[0-9]{8}$/,
              })}
            />
            {CFV("phone", "פורמט מספר פלאפון לא חוקי", errors)}
          </div>
          <div style={{ width: "25%" }}>
            <Label>רשומות</Label>
            <Input disabled={true} defaultValue={user.records} />
          </div>
          <div style={{ width: "25%" }}>
            <Label>דיל (₪)</Label>
            <Input
              defaultValue={user.deal}
              type="number"
              step={0.05}
              {...register("deal", {
                required: true,
                min: 0,
                max: 3,
              })}
            />
            {CFV(`deal`, `מספר בין 0 ל 3`, errors)}
          </div>
        </FlexRowBetween>
        <FlexRowBetween>
          <div style={{ width: "100%" }}>
            <Label>ניווט</Label>
            <Input
              defaultValue={user.waze}
              disabled={true}
              type="text"
              {...register("waze", {
                minLength: 0,
                maxLength: 50,
              })}
            />
            {CFV("waze", "בין 2 ל 20 תווים", errors)}
          </div>
        </FlexRowBetween>

        <FlexRowBetween>
          <div style={{ width: "100%" }}>
            <Label>אשראי</Label>
            <Input
              defaultValue={user.paybox}
              disabled={true}
              type="text"
              {...register("paybox", {
                minLength: 0,
                maxLength: 50,
              })}
            />
            {CFV("paybox", "בין 2 ל 20 תווים", errors)}
          </div>
        </FlexRowBetween>

        <Label>הערות</Label>
        <TextArea
          defaultValue={user.description}
          type="text"
          rows="3"
          {...register("description", {
            minLength: 0,
            maxLength: 500,
          })}
        />
        {CFV("description", "עד 500 תווים", errors)}
        {/* <div style={{ width: "100%", overflowX: "auto" }}></div> */}
        <FlexRowBetween>
          <div style={{ width: "max-content", textAlign: "right" }}>
            <Label>הושבה</Label>
            <Switcher
              onOfColor={"#C0C0C0"}
              color={"#7b96c4"}
              checked={isDigitalSeat}
              onChange={() => setIsDigitalSeat(!isDigitalSeat)}
            />
          </div>

          {isDigitalSeat && (
            <div style={{ width: "max-content", textAlign: "right" }}>
              <Label>סקיצה</Label>
              <Switcher
                onOfColor={"#C0C0C0"}
                color={"#7b96c4"}
                checked={canEditSketch}
                onChange={() => setCanEditSketch(!canEditSketch)}
              />
            </div>
          )}

          {isDigitalSeat && (
            <div style={{ width: "max-content", textAlign: "right" }}>
              <Label>דיגיטלית</Label>
              <Switcher
                onOfColor={"#C0C0C0"}
                color={"#7b96c4"}
                checked={sendSeatSMS}
                onChange={() => setSendSeatSMS(!sendSeatSMS)}
              />
            </div>
          )}
          {/* <div style={{ width: "max-content", textAlign: "right" }}>
            <Label style={{ marginLeft: "0px", textAlign: "right" }}>
              רשאי לוז?
            </Label>
            <Switcher
              onOfColor={"#C0C0C0"}
              color={"#7b96c4"}
              checked={canChangeTodos}
              onChange={() => setCanChangeTodos(!canChangeTodos)}
            />
          </div> */}
        </FlexRowBetween>
        <FlexRowBetween style={{ marginTop: "10px" }}>
          <div style={{ width: "max-content", textAlign: "right" }}>
            <Label>שולם?</Label>
            <Switcher
              onOfColor={"#C0C0C0"}
              color={"#7b96c4"}
              checked={isPaid}
              onChange={() => setIsPaid(!isPaid)}
            />
          </div>
          <CopyText
            marginLeft={"5px"}
            dataToCopy={msg0}
            text={"התחברות"}
            padding="4px"
            image={true}
          />
          {(up == "דובי הפקות" || up == "שלי חסווה הפקות") && (
            <div
              style={{
                border: "1px solid #a8a6a6",
                padding: "3px 7px",
                borderRadius: "5px",
                fontSize: "14px",
              }}
              onClick={handleCreateIBSuser}
            >
              פתיחת אשראי
            </div>
          )}
          <div style={{ width: "100px", textAlign: "right" }}>
            <Label>הושבה (₪)</Label>
            <Input
              defaultValue={user.digitalSeatCost}
              type="number"
              {...register("digitalSeatCost", {
                required: true,
                min: 0,
                max: 10000,
              })}
            />
            {CFV(`digitalSeatCost`, `מספר בין 0 ל 10000`, errors)}
          </div>
        </FlexRowBetween>

        {(up == "משחק הכיסאות" || up == "מארגנת החתונות" || up == "TipTop") && (
          <FlexRowBetween>
            <div
              style={{
                border: "2px solid #a8a6a6",
                padding: "5px 8px",
                borderRadius: "2px",
              }}
              onClick={handleCreateIBSuser}
            >
              פתיחת אשראי
            </div>

            <CopyText
              marginLeft={"5px"}
              dataToCopy={msg5}
              text={"פינישים"}
              padding="4px"
              image={false}
            />

            <div style={{ width: "max-content", textAlign: "right" }}>
              <Label
                onClick={() => {
                  handleCountNotAnswered(user._id);
                }}
              >
                מוכן?
              </Label>
              <Switcher
                onOfColor={"#C0C0C0"}
                color={"#7b96c4"}
                checked={isReadyAdmin}
                onChange={() => setIsReadyAdmin(!isReadyAdmin)}
              />
            </div>
          </FlexRowBetween>
        )}

        <FlexRowBetween style={{ marginTop: "50px" }}>
          <a
            href={
              "tel:" +
              (user.phone[0] === "0" ? user.phone : "0" + user.phone + "")
            }
          >
            <GenericDiv
              background={"rgba(123,150,196,0.95)"}
              style={{ padding: "8px 8px" }}
            >
              <img src={call} alt={"call"} style={{ width: "23px" }} />
            </GenericDiv>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://wa.me/972${user.phone}/?text=`}
          >
            <GenericDiv
              background={"rgba(123,150,196,0.95)"}
              style={{ margin: "0 20px", padding: "4px 4px" }}
            >
              <img
                src={whatsappW}
                alt={"whatsappW"}
                style={{ width: "31px" }}
              />
            </GenericDiv>
          </a>
          <Button style={{ width: "100%" }}>שמירה</Button>
          <GenericDiv
            onClick={() => setShowDelete(true)}
            background={"rgba(41,59,90,0.95)"}
            style={{ marginRight: "20px", padding: "9px 10px" }}
          >
            <img src={trash} alt="trash" style={{ width: "21px" }} />
          </GenericDiv>
        </FlexRowBetween>
      </div>

      {loading && <OpacityLoading />}

      {showCalendar && (
        <GenericModal
          init={setShowCalendar}
          div={
            <GCalendar
              setDate={handleSetDate}
              date={date}
              init={setShowCalendar}
            />
          }
        />
      )}

      {showStats && (
        <GenericModal init={setShowStats} div={<Stats user={showStats} />} />
      )}

      {showAsmachta && (
        <GenericModal
          init={setShowAsmachta}
          div={
            <img
              src={`${getImageUrl()}${user._id}/${user.asmachta}`}
              style={{ width: "90%", maxWidth: "500px" }}
            />
          }
        />
      )}

      {showDelete && (
        <GenericModal
          init={setShowDelete}
          div={
            <YesNoModal
              title={"מחיקת אירוע"}
              body={"האם את/ה בטוח/ה שברצונך למחוק אירוע זה?"}
              no={setShowDelete}
              yes={handleDestroyUser}
            />
          }
        />
      )}
    </PopupForm>
  );
};

export default EditUser;
